<template>
  <div id="about">
    <div class="page-header">
      <img class="header-img" src="@/assets/images/about/header-img.jpg" />
      <div class="header-title">World Federation</div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="In Brief" name="Brief">
        <div class="page-content">
          <div class="content-view">
            <div class="page-title" id="bar1">Who We Are?</div>
            <div class="img-view">
              <div class="img-text one">
                <p>
                  The World Federation of UNESCO Clubs and Associations (hereinafter referred to as
                  "the World Federation"), abbreviated as "WFUCA," is a non-governmental
                  organization in official partnership (associate status) with UNESCO.
                </p>

                <p>
                  In 1978, the General Conference of UNESCO, through its Resolution 6/32 at the 20th
                  session, invited the Director-General and Member States to support the
                  establishment of a World Federation of UNESCO Clubs.
                </p>

                <p>
                  This initiative led to the establishment of the World Federation in July 1981
                  during a convention of National Federations of UNESCO Clubs and Associations at
                  UNESCO Headquarters in Paris. The headquarters of the World Federation is located
                  in the UNESCO annex building in Paris, France.
                </p>

                <p>
                  As of today, the World Federation's membership spans all continents. It consists
                  of 47 full members, who are the National Coordination Structures or Federations of
                  Clubs and Associations for UNESCO, and 27 associate members, who have yet to be
                  federated at the national level or have not been accredited by their respective
                  National Commission for UNESCO.
                </p>

                <p>
                  Additionally, under the supervision and guidance of the World Federation, there
                  are five regional federations of UNESCO Clubs and Associations that function as
                  independent coordinating bodies, namely:
                </p>

                <ul>
                  <li>Asian-Pacific Federation of Clubs and associations for UNESCO (AFUCA)</li>
                  <li>European Federation of UNESCO Clubs and Associations (EFUCA)</li>
                  <li>Confederation of African UNESCO Clubs (CACU)</li>
                  <li>Arab Federation of UNESCO Clubs and Associations (FEDACLU)</li>
                  <li>
                    Federation of Latin America and the Caribbean of Associations and Clubs UNESCO
                    (FLACACU)
                  </li>
                </ul>
              </div>
              <img src="@/assets/images/about/about-01.jpg" />
            </div>

            <div class="page-title" id="bar2">WFUCA Mission & Vision</div>
            <div class="text">
              <p>
                Since its establishment, WFUCA has been committed to the development of UNESCO's
                ideals and objectives; meanwhile, WFUCA also holds the responsibility to promote and
                develop UNESCO's priorities, programmes and guidelines; its aims and objectives are:
              </p>
              <p>1. To further the ideals of UNESCO ;</p>
              <ul>
                <li>
                  to promote international understanding and education, with a particular view to
                  the effective exercise of human rights and the endogenous and sustainable
                  development of all peoples;
                </li>
                <li>
                  to foster dialogue among nations and peoples with a particular view to advancing
                  mutual understanding among the different cultures and civilizations of the world;
                </li>
                <li>
                  to promote the utilization of science and technology for peaceful purposes, for
                  the welfare of humanity
                </li>
                <li>
                  to promote in all societies the right of every person and every people to a
                  cultural identity, with due regard for cultural diversity;
                </li>
                <li>
                  to ensure in the management of human activities the preservation of the natural
                  environment for present and future generations;
                </li>
              </ul>
              <p>2. To further the programmes, priorities and guidelines of UNESCO;</p>
              <p>
                3. To that end, to strengthen and encourage the development of UNESCO Clubs and
                Associations.
              </p>
            </div>

            <div class="page-title" id="bar3">What are our Priorities?</div>
            <div class="our-view">
              <div class="our-item">
                <img src="@/assets/images/about/our-01.png" alt="" />
                <div class="our-text">
                  <div class="text-title">Education</div>
                  <div class="text-content">
                    Global citizenship education (GCED);
                    <br />
                    Technical and Vocational Education and Training (TVET);
                    <br />
                    Lifelong Learning
                  </div>
                </div>
              </div>

              <div class="our-item">
                <img src="@/assets/images/about/our-02.png" alt="" />
                <div class="our-text">
                  <div class="text-title">Culture</div>
                  <div class="text-content">
                    World Heritage Protection and Preservation;
                    <br />
                    Intangible Cultural Heritage Safeguarding;
                    <br />
                    Culture and Arts Education;
                  </div>
                </div>
              </div>

              <div class="our-item">
                <img src="@/assets/images/about/our-03.png" alt="" />
                <div class="our-text">
                  <div class="text-title">Science</div>
                  <div class="text-content">
                    Sustainable Development;
                    <br />
                    Climate Change;
                    <br />
                    Ocean & Water;
                  </div>
                </div>
              </div>

              <div class="our-item">
                <img src="@/assets/images/about/our-04.png" alt="" />
                <div class="our-text">
                  <div class="text-title">Youth</div>
                  <div class="text-content">
                    Intercultural Dialogue and Peace;
                    <br />
                    Meaningful Youth Engagement;
                    <br />
                    Gender Equality.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 侧边栏 -->
          <ul class="side-bar">
            <t-anchor :affixProps="{ offsetTop: affixTop }">
              <t-anchor-item
                v-for="item in barList"
                :href="`#${item.id}`"
                :title="item.name"
                style="white-space: nowrap"
              ></t-anchor-item>
            </t-anchor>
            <!-- <li
              v-for="item in barList"
              :key="item.name"
              :class="{ active: currentBar == item.id }"
            >
              <a href="javascript:;" @click="scrollTo(item)">{{ item.name }}</a>
            </li> -->
          </ul>
        </div>
      </el-tab-pane>

      <el-tab-pane label="Organs & Branches" name="Branches">
        <aboutOB></aboutOB>
      </el-tab-pane>

      <el-tab-pane label="Constitution" name="Constitution">
        <div class="page-content">
          <div class="content-view constitution">
            <div class="page-title" id="bar3">Constitution</div>
            <div class="img-view2">
              <img src="@/assets/images/about/about-31.png" />
              <div class="img-info">
                <div class="info-title">Preamble</div>
                <div class="info-text">
                  <p>
                    We, the representatives of
                    <b style="font-size: 16px">Clubs and Associations for UNESCO</b> in our
                    respective countries:
                  </p>

                  <p>
                    1. <span style="font-size: 16px">Recalling</span> that the Constitution of the
                    United Nations Educational, Scientific and Cultural Organization (UNESCO) states
                    that "since wars begin in the minds of men, it is in the minds of men that the
                    defences of peace must be constructed",
                  </p>

                  <p>
                    2. <span style="font-size: 16px">Reaffirming</span> our faith in the ideals,
                    principles and actions of UNESCO, whose purpose is to "contribute to peace and
                    security by promoting collaboration among nations through education, science and
                    culture in order to further universal respect for justice, for the rule of law
                    and for the human rights and fundamental freedoms which are affirmed for the
                    peoples of the world, without distinction of race, sex, language or religion by
                    the Charter of the United Nations'',
                  </p>

                  <p>
                    3. <span style="font-size: 16px">Considering</span> 3.that "a peace based
                    exclusively upon the political and economic arrangements of governments would
                    not be a peace which could secure the unanimous, lasting and sincere support
                    [...] and that the peace must therefore be founded, if it is not to fail, upon
                    the intellectual and moral solidarity of mankind'',
                  </p>

                  <p>
                    4. <span style="font-size: 16px">Realizing</span> 4.the need for active,
                    meaningful and direct participation by the peoples of the world in the
                    achievement of UNESCO's ideals, and the role of voluntary organizations in this
                    connection,
                  </p>

                  <p>
                    Do hereby establish an international non-governmental organization to be called
                    the
                    <b style="font-size: 16px"
                      >World Federation of Clubs and Associations for UNESCO</b
                    >
                    (hereinafter referred to as “the World Federation”), the acronym of which shall
                    be “WFUCA”, the name and acronym in French of which shall be
                    <b style="font-size: 16px"
                      >Fédération mondiale des associations et clubs pour l’UNESCO, and “FMACU”</b
                    >, and for this purpose have agreed to adopt the following Constitution:
                  </p>
                </div>
              </div>
            </div>

            <div class="article-list">
              <div class="list-row">
                <div class="article-item" @click="goArticle('1')">
                  Article 1 – Objectives and Functions
                </div>
                <div class="article-item" @click="goArticle('2')">Article 2 – Headquarters</div>
                <div class="article-item" @click="goArticle('3')">
                  Article 3 – Membership Status
                </div>
                <div class="article-item" @click="goArticle('4')">Article 4 – Organs</div>
                <div class="article-item" @click="goArticle('5')">Article 5 – World Congress</div>
                <div class="article-item" @click="goArticle('6')">Article 6 – Executive Board</div>
                <div class="article-item" @click="goArticle('7')">Article 7 – Secretariat</div>
                <div class="article-item" @click="goArticle('8')">Article 8 – Advisors</div>
              </div>

              <div class="list-row">
                <div class="article-item" @click="goArticle('9')">Article 9 – Procedures</div>
                <div class="article-item" @click="goArticle('10')">Article 10 – Finances</div>
                <div class="article-item" @click="goArticle('11')">
                  Article 11 – Amendments and Dissolution
                </div>
                <div class="article-item" @click="goArticle('12')">
                  Article 12 – Entry into Force
                </div>

                <div class="article-item" @click="goArticle('13')">ARTICLE 13 - AMENDMENTS</div>
                <div class="article-item" @click="goArticle('14')">
                  ARTICLE 14 - USE OF UNESCO LOGO AND NAME ETC
                </div>
                <div class="article-item" @click="goArticle('15')">
                  ARTICLE 15 - ENTRY INTO FORCE
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="Milestones" name="Milestones">
        <aboutMilestones></aboutMilestones>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="68%"
      top="8vh"
      :before-close="handleClose"
    >
      <div class="article" v-if="currentArticle == 1">
        <div class="a-title">ARTICLE 1 - OBJECTIVES AND FUNCTIONS</div>
        <div class="s-title">Section 1 -Objectives</div>
        <p>The objectives of the World Federation shall be:</p>
        <p>1. to further the ideals of UNESCO:</p>
        <p>
          (a) to promote international understanding and education, with a particular view to the
          effective exercise of human rights and the endogenous and sustainable development of all
          peoples;
        </p>
        <p>
          (b) to foster dialogue among nations and peoples with a particular view to advancing
          mutual understanding among the different cultures and civilizations of the world;
        </p>
        <p>
          (c) to promote the utilization of science and technology for peaceful purposes, for the
          welfare of humanity;
        </p>
        <p>
          (d) to promote in all societies the right of every people to a cultural identity, with due
          regard for cultural diversity;
        </p>
        <p>
          (e) to ensure in the management of human activities the preservation of the natural
          environment for present and future generations;
        </p>
        <p>
          (f) to promote awareness/understanding about climate change, its assessment, impact and
          options for community adaptation
        </p>
        <p>
          (g) to spread information for Sustainable Development and contribute in its implementation
        </p>
        <p>2. to further the programmes, priorities and guidelines of UNESCO;</p>
        <p>
          3. and, to that end, to strengthen and encourage the development of Clubs and Associations
          for UNESCO.
        </p>
        <div class="s-title">Section 2 - Functions</div>
        <p>To achieve these objectives, the World Federation shall have the following functions:</p>
        <p>
          (a) to organize and support the coordinated and mutually supportive joint action of its
          members;
        </p>
        <p>
          (b) to assist in the establishment of national and regional Federations where none yet
          exist, on the basis of UNESCO's definition of regions;
        </p>
        <p>
          (c) to evaluate its member structures in liaison with the National Commissions and with
          UNESCO;
        </p>
        <p>
          <!-- (d) to foster cooperation between National Federations of Clubs for UNESCO and Associated
          Schools and other UNESCO networks;  -->
          (d) to foster cooperation between National Federations of Clubs and Associations for
          UNESCO, Associated Schools and other UNESCO networks;
        </p>
        <p>
          (e) to circulate information by helping to improve the preparation, collection,
          distribution and exchange of printed, audio visual and digital materials; to organize
          exchange programmes, workshops, symposia, seminars and training for members;
        </p>
        <p>
          (f) to organize exchange programmes, workshops, symposia, seminars and training for
          members;
        </p>
        <p>(g) to organize/facilitate fund-raising campaigns for financing its programmes;</p>

        <p>(h) to take any action directed towards the achievement of its aims and objectives.</p>
      </div>
      <div class="article" v-else-if="currentArticle == 2">
        <div class="a-title">ARTICLE 2 - HEADQUARTERS</div>
        <p>The World Federation's headquarters shall be located in Paris, France.</p>
        <p>
          Its headquarters may be transferred by decision of the World Congress, adopted by a
          two-thirds majority of full members present and voting.
        </p>
      </div>
      <div class="article" v-else-if="currentArticle == 3">
        <div class="a-title">ARTICLE 3 - MEMBERSHIP STATUS</div>
        <div class="s-title">Section 1 - Categories of Members</div>
        <p>The World Federation shall be composed of following categories:</p>
        <p>
          1. Full members: National Coordination Structures or Federations of Clubs and Associations
          for UNESCO, covering at least three regularly established Clubs and Associations for
          UNESCO for at least one year under the supervision of the National Commission for UNESCO
          of that country. No more than one full member may be admitted per country. They shall be
          entitled to vote and to stand for election at the World Congress subject to payment of the
          dues set out in this Constitution;
        </p>
        <p>
          2. Associate members: Structures of Clubs or Associations for UNESCO recommended by a
          country's National Commission for UNESCO where they have yet to be federated at national
          level or to attain the number stipulated in subparagraph 1 of this article. They shall act
          in an advisory capacity until progress has been made towards the setting up of a National
          Federation. They may attend the World Congress as an observer without having any voting
          right;
        </p>
        <p>
          3. Honorary members and Benefactors: structures or individuals that have rendered or are
          likely to render services to the UNESCO Clubs Movement or that simply represent values
          close to the ideals championed by UNESCO Clubs Movement.
        </p>
        <div class="s-title">Section 2 - Admission</div>
        <p>
          Any structure wishing to join the World Federation as a Full member or Associate member as
          mentioned above must submit:
        </p>
        <p>
          (a) A request for membership to the President of the World Federation along with a brief
          description of the structure and list of its members with addresses;
        </p>
        <p>
          (b) A letter of recommendation from the National Commission for UNESCO of its country. The
          request shall be examined by the Secretariat, before presenting it at the next session of
          the Executive Board.
        </p>
        <p>
          Provisional admission or refusal shall be determined by the Executive Board. Applicants
          shall be notified in writing by the President of the decision of the Executive Board.
          Final admission shall be determined by the World Congress.
        </p>
        <p>
          In case of the provisional admission, applicant shall be asked to pay the required
          membership fee within 60 days or at the time of World Congress, whichever is earlier.
        </p>
      </div>
      <div class="article" v-else-if="currentArticle == 4">
        <div class="a-title">ARTICLE 4 - ORGANS</div>
        <p>The main organs of the World Federation are:</p>
        <p>(a) the World Congress;</p>
        <p>(b) the Executive Board;</p>
        <p>(c) the Secretariat.</p>
      </div>
      <div class="article" v-else-if="currentArticle == 5">
        <div class="a-title">ARTICLE 5 - WORLD CONGRESS</div>
        <div class="s-title">Section 1 - Composition</div>

        <div class="s-title"></div>
        <div class="s-title"></div>
        <p>
          The World Congress is the main organ of the World Federation and is composed of delegates
          duly nominated by the full members. Only one delegate per full member shall have the right
          to vote provided all membership dues are paid by such full member. Associate members and
          alternate delegates may participate as observers.
        </p>
        <div class="s-title">Section 2 - Credentials Committee</div>
        <p>
          A Credentials Committee, nominated by the World Congress, shall examine the credentials of
          delegates before their admission, in accordance with the Constitution.
        </p>
        <div class="s-title">Section 3 - Functions of the World Congress</div>
        <p>
          The World Congress is the supreme authority through which the issues, mechanism for
          coordination and integration of the World Federation's programmes may be addressed. It
          shall have the following main functions:
        </p>
        <p>(a) to adopt the General Rules of the World Congress of WFUCA;</p>
        <p>(b) to lay down guidelines for the proper functioning of the World Federation;</p>
        <p>
          (c) to approve the activity and financial reports for the period since the previous World
          Congress;
        </p>
        <p>
          (d) to adopt the programme and budgetary guidelines proposed by the Executive Board for
          the period up to the following World Congress;
        </p>
        <p>
          (e) to elect, the President of the World Federation, five Vice-Presidents, five members of
          the Executive Board and the Treasurer. Equitable geographical distribution shall be taken
          into account in these elections. Elected President shall not be of the same nationality as
          of his/her predecessor;
        </p>
        <div class="s-title">Section 4 - Ordinary Session/s</div>
        <p>(a) The World Congress shall meet in ordinary session every four years.</p>
        <p>
          (b) The World Congress shall determine the date and place of the next session. Should it
          fail to do so, the Executive Board shall make the decision.
        </p>
        <div class="s-title">Section 5 - Extraordinary Session/s</div>
        <p>
          (a) An extraordinary session of the World Congress may be convened by the President of the
          World Federation, or at the request of two thirds of the full members (up to date with
          their dues) or two thirds of the members of the Executive Board.
        </p>
        <p>
          (b) An extraordinary session shall concern itself only with the questions for which it has
          been convened.
        </p>
        <div class="s-title">Section 6 - Agenda of Ordinary Sessions of the World Congress</div>
        <p>
          The Executive Board shall prepare a Pre-Draft Agenda to be circulated to all members at
          least four months before the opening of an ordinary session. Members shall submit any
          comments not less than two months before opening of the session.
        </p>
        <p>
          The Executive Board shall then prepare a provisional agenda based on the comments and
          suggestions received, for circulation to members and observers.
        </p>

        <div class="s-title">Section 7 - Officers of the World Congress</div>
        <p>
          At the first plenary meeting of each World Congress, the duly accredited delegates shall
          elect the following officers of the World Congress: Chairperson, Deputy Chairperson,
          General "Rapporteur" and Deputy "Rapporteurs", if required.
        </p>
      </div>
      <div class="article" v-else-if="currentArticle == 6">
        <div class="a-title">ARTICLE 6 - EXECUTIVE BOARD</div>
        <div class="s-title">Section 1 - Composition</div>
        <p>(a) The Executive Board shall consist of the following members:</p>
        <p>
          The President, five Vice-Presidents, five members and a Treasurer duly elected by the
          World Congress together with ex-officio members (the representatives of National
          Federations fulfilling the criteria laid down in the Rules of Procedures of the Executive
          Board, admitted in that capacity by the Executive Board, with approval of the World
          Congress).
        </p>
        <p>
          Representatives of regional Federations may be invited to take part in the proceedings in
          an advisory capacity.
        </p>
        <p>
          (b) A representative of UNESCO shall be invited to take part in the proceedings of the
          Executive Board in an advisory capacity.
        </p>
        <p>
          (c) Members of the Executive Board shall take office immediately after completion of the
          proceedings of the World Congress, and serve for a period of four years until their
          successors are elected at the following ordinary session of the World Congress. They shall
          be eligible for re-election to serve a second term, in the capacity for which elected for
          the first term. (d) Every member of the Executive Board shall act in his/her personal
          capacity.
        </p>
        <p>
          (e) If an elected member of the Executive Board is unable to serve until the end of
          his/her term, the Executive Board shall nominate a person from the same region as the
          outgoing member to serve for the unexpired portion of the term.
        </p>
        <div class="s-title">Section 2 - Office Bearers</div>
        <p>• President:</p>
        <p>
          He/she is the head/chief Executive responsible for the general policy and management of
          the World Federation. The President shall convene the sessions of the World Congress and
          the Executive Board; shall chair meetings of the Executive Board; appoint the Secretary
          General and staff of the Secretariat.
        </p>
        <p>• Vice-Presidents:</p>
        <p>
          They shall be elected on the basis of UNESCO’s definition of regions and be responsible
          for the regional coordination of the World Federation. They shall assist the President in
          all of his/her functions. In the event of any impediment, they should elect one of them to
          assume the duties and responsibilities of the President on a temporary basis.
        </p>
        <p>• Treasurer:</p>
        <p>
          He/she shall be responsible for all matters regarding the management of the funds/assets
          and prepare the financial statement, draw up and submit the draft budget etc.
        </p>
        <div class="s-title">Section 3 - Responsibilities and Functions</div>
        <p>
          The Executive Board shall be responsible to the World Congress for fulfilling the
          functions of the World Federation, and in particular for:
        </p>
        <p>(a) preparing the draft agenda of the World Congress;</p>
        <p>
          (b) examining and submitting to the World Congress, with its recommendations, the draft
          programme and budget of the World Federation; then ensuring implementation of the approved
          programme and budget by the Secretariat;
        </p>
        <p>(c) implementing the decisions of the World Congress;</p>
        <p>
          (d) preparing the draft General Rules of the World Congress and proposing them to the
          World Congress;
        </p>
        <p>
          (e) examining membership applications and deciding the provisional admission of new
          members;
        </p>
        <p>(f) performing the other functions as may be required by the World Congress.</p>
        <div class="s-title">Section 4 - Ordinary Sessions</div>
        <p>
          The Executive Board shall meet in ordinary session immediately before and after the World
          Congress and at least once between two sessions of the World Congress.
        </p>
        <div class="s-title">Section 5 - Extraordinary Sessions</div>
        <p>
          The Executive Board may meet in extraordinary session at the request of the President or
          of at least two thirds of its members.
        </p>
      </div>
      <div class="article" v-else-if="currentArticle == 7">
        <div class="a-title">ARTICLE 7 - SECRETARIAT</div>
        <div class="s-title">Section 1 - Composition</div>
        <p>
          The Secretariat shall be composed of a Secretary General and such staff as may be required
          and appointed by the President.
        </p>
        <div class="s-title">Section 2 - Secretary General</div>
        <p>He/she shall be appointed for a term to be decided by the President.</p>
        <p>His/her functions shall be, inter alia, to:</p>
        <p>- assume administrative and financial responsibility for the Secretariat;</p>
        <p>- direct the staff of the Secretariat;</p>
        <p>
          - present to the Executive Board and World Congress, a report on the activities carried
          out by the World Federation, and a financial report (in agreement with the Treasurer);
        </p>
        <p>- assist in coordinating and implementing programmes.</p>
      </div>
      <div class="article" v-else-if="currentArticle == 8">
        <div class="a-title">ARTICLE 8 - REGIONAL FEDERATION AND COORDINATING COMMITTEES</div>
        <div class="s-title">Section 1 - Creation</div>
        <p>
          Regional Federations and Coordinating Committees are created within the framework of the
          World Federation.
        </p>
        <div class="s-title">Section 2 - Functions</div>
        <p>
          Their function shall be to encourage and coordinate on regional basis, development of the
          Clubs for UNESCO Movement and to coordinate the programs of the World Federation on
          regional level.
        </p>
        <div class="s-title">Section 3 - Relations with the World Federation</div>
        <p>
          They shall function in their corresponding region, within the framework of the World
          Federation and shall be bound by the terms of the Constitution, and shall invite the
          Secretariat of the World Federation to observe its statutory meetings.
        </p>
      </div>
      <div class="article" v-else-if="currentArticle == 9">
        <div class="a-title">ARTICLE 9 - SPECIALIZED COMMITTEES</div>
        <div class="s-title">Section 1 - Creation</div>
        <p>
          Specialized committees shall be established with the approval of the Executive Board,
          based on the proposal of either the President or the Secretary-General, in accordance with
          the World Federation's Constitution. The Secretariat is responsible for the routine
          management of the Committee.
        </p>
        <div class="s-title">Section 2 - Functions</div>
        <p>
          Their function shall be to foster the growth of the UNESCO Clubs Movement in a specific
          area by gathering diverse professional expertise and experiences, and to advance the work
          of the World Federation through cooperation, coordination, and sharing of best practices.
          Its activities shall adhere to the Constitution of the World Federation.
        </p>
        <div class="s-title">Section 3 - Composition</div>
        <p>
          The organizational structure of a specialized committee is tailored to meet the practical
          needs of its work, and its leadership and members are appointed by the President based on
          recommendations from the Executive Board and the Secretariat. Committee members are
          selected for their expertise and professional qualifications in the relevant field, and
          may be drawn from the member of the World Federation or other specialized institutions.
        </p>
      </div>
      <div class="article" v-else-if="currentArticle == 10">
        <div class="a-title">ARTICLE 10 - ADVISOR(S)</div>
        <div class="s-title">Section 1 - Definition</div>
        <p>
          The advisors shall preferably be members or former members of the World Federation with
          particular experience in areas corresponding to the major orientations of the World
          Federation, or who possess specialized professional skills valuable to the functioning of
          the World Federation, and who place that experience and those skills at the disposal of
          the organs of the World Federation.
        </p>
        <div class="s-title">Section 2 - Functions</div>
        <p>
          The functions of advisors are consultative. They may be given assignments for which the
          President, the members of the Executive Board and the Secretary General are responsible.
        </p>
        <p>
          Advisors shall be consulted or called to meetings depending upon the tasks in hand and the
          degree of expertise required. Their role as advisors may be terminated by a decision of
          the Executive Board.
        </p>
        <div class="s-title">Section 3 - Appointment</div>
        <p>
          Advisors shall be appointed by the President on recommendation of the Executive Board by
          two thirds of its members.
        </p>
      </div>
      <div class="article" v-else-if="currentArticle == 11">
        <div class="a-title">ARTICLE 11 - PROCEDURES</div>
        <div class="s-title">Section 1 - Notification</div>
        <p>(a) World Congress</p>
        <p>
          The Secretary General, acting on the instructions of the President, informs members of
          each session of the World Congress within the following time-limits:
        </p>
        <p>
          - notice of an ordinary session of the World Congress shall be given at least six months
          in advance, at which time the Pre-Draft Agenda shall be sent to members;
        </p>
        <p>
          - notice of the acceptance of delegates and observers shall be given at least two months
          in advance of the World Congress;
        </p>
        <p>
          - notice of an extraordinary session shall be given at least three months in advance,
          stating the purpose for which the session is being convened.
        </p>
        <p>(b) Executive Board</p>
        <p>
          The Secretary General, acting on the instructions of the President, shall give notice to
          members of each session of the Board as follows:
        </p>
        <p>
          - notice of an ordinary session shall be given at least one month in advance, at which
          time the Pre-Draft Agenda of the session shall be sent to members of the Executive Board;
        </p>
        <p>
          - notice of an extraordinary session shall be given at least two weeks in advance, stating
          the purpose for which the session is being convened.
        </p>
        <div class="s-title">Section 2 - Quorum</div>

        <p>
          (a) At plenary sessions of the World Congress, a quorum shall consist of a simple majority
          of full members up to date with their dues.
        </p>
        <p>
          (b) At sessions of the Executive Board, a quorum shall consist of a majority of Board
          members.
        </p>
        <div class="s-title">Section 3 - Decisions</div>
        <p>
          The decisions of the World Congress, the Executive Board and other committees shall be
          taken by a simple majority of those present and voting.
        </p>
        <div class="s-title">Section 4 - Voting</div>
        <p>
          (a) Each full member of the World Federation shall have one vote in the World Congress.
          Other members may take part in the discussions without the right to vote.
        </p>
        <p>
          (b) The President, Vice-Presidents, members and the Treasurer are elected by an absolute
          majority (two thirds) of full members present and voting. Posts not filled in the first
          ballot by absolute majority shall be reconsidered in a second ballot by a simple majority.
        </p>
        <p>(c) Each member of the Executive Board shall have one vote in Board decisions.</p>
      </div>
      <div class="article" v-else-if="currentArticle == 12">
        <div class="a-title">ARTICLE 12 - FINANCES</div>
        <div class="s-title">Section 1 - Financial Arrangements and Membership Dues</div>
        <p>The annual income of the World Federation shall consist of:</p>
        <p>(a) dues of full members;</p>
        <p>(b) dues from honorary members and benefactors;</p>
        <p>(c) contributions from States and National and International Organizations;</p>
        <p>(d) income from special activities and miscellaneous resources.</p>
        <div class="s-title">Section 2 - Payment of Dues</div>
        <p>
          The scale of dues payable annually by members shall be established by the World Congress
          on the proposal of the Executive Board. The Executive Board shall make appropriate
          arrangements for the collection and administration of the World Federation's resources.
        </p>
        <p>Consequences of Non-payment of membership fees:</p>
        <p>
          (a) Members who have not paid their annual membership fees for two consecutive years,
          their rights shall be suspended.
        </p>
        <p>
          (b) Members who have not paid their annual membership fees for four consecutive years may
          lose their member status after notifications to the National Commission of that country.
        </p>
        <p>
          (c) In applying paragraphs (a) and (b) above, justifications for non-payment will be taken
          into consideration by the Executive Board.
        </p>

        <div class="s-title">Section 3 - Accounts</div>
        <p>
          The Treasurer, in liaison with the Secretary General, shall prepare the World Federation's
          statement of accounts for each financial year, which shall correspond to the calendar
          year, and shall submit it for approval to the Executive Board.
        </p>
      </div>

      <div class="article" v-else-if="currentArticle == 13">
        <div class="a-title">ARTICLE 13 - AMENDMENTS</div>
        <div class="s-title"></div>
        <p>
          Amendments to this Constitution may be proposed by a full member or by the Executive
          Board.
        </p>
        <p>
          Any proposal to amend the Constitution of the World Federation must be received by the
          Secretary General at least six months before an ordinary session of the World Congress.
        </p>
        <p>
          Such proposals, together with the comments of the Executive Board, shall be circulated to
          members with the Pre-Draft Agenda of the ordinary session at least three months before the
          opening of the ordinary session of the World Congress.
        </p>
        <p>
          Amendments to this Constitution may be adopted only by the World Congress by a two-thirds
          majority vote of the delegates present and voting, and shall be effective on their
          adoption.
        </p>
      </div>

      <div class="article" v-else-if="currentArticle == 14">
        <div class="a-title">ARTICLE 14 - USE OF UNESCO LOGO AND NAME ETC</div>
        <p>
          The members of the World Federation should strictly comply with the UNESCO directives
          concerning the use of name, acronym, logo and internet domain names of UNESCO.
        </p>
      </div>

      <div class="article" v-else-if="currentArticle == 15">
        <div class="a-title">ARTICLE 15 - ENTRY INTO FORCE</div>
        <div class="s-title"></div>
        <p>
          This Constitution was originally adopted by the second World Congress of UNESCO Clubs,
          Centres and Associations at its session held in Paris on 3 July 1981, and subsequently
          revised by the following World Congress of the World Federation:
        </p>
        <p>
          - the 2nd World Congress of the World Federation of UNESCO Clubs, Centres and Associations
          held in Madrid on 22 July 1987,
        </p>
        <p>
          - the Extraordinary session of World Congress of the World Federation of UNESCO Clubs,
          Centres and Associations held in Paris, France on 20th July 2005,
        </p>
        <p>
          - the 9th World Congress of the World Federation of UNESCO Clubs, Centres and Associations
          held in Beijing, Peoples Republic of China 21-25 July 2015.
        </p>
        <p>
          - the 10th World Congress of the World Federation of UNESCO Clubs, Centres and
          Associations held in Seoul, Republic of Korea 26-29 October 2023.
        </p>
        <p>It takes effect immediately.</p>
      </div>

      <!--      <div slot="footer" class="dialog-footer">-->
      <!--        <el-button @click="dialogVisible = false">取 消</el-button>-->
      <!--        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>-->
      <!--      </div>-->
    </el-dialog>
  </div>
</template>

<script>
import { nextTick } from "vue";
import aboutMilestones from "@/views/components/about-milestones.vue";
import aboutOB from "@/views/components/about-ob.vue";

export default {
  name: "About",
  components: { aboutMilestones, aboutOB },
  data() {
    return {
      affixTop: 600,
      activeName: "Brief",
      // activeName: 'Branches',
      currentArticle: 1,
      dialogVisible: false,
      scrollOn: true,
      currentBar: "bar1",
      barList: [
        { name: "Who We Are? ", id: "bar1", active: 1 },
        { name: "What we do?", id: "bar2", active: 0 },
        { name: "What are our Priorities?  ", id: "bar3", active: 0 },
      ],
    };
  },
  mounted() {
    // 获取每个模块的参数，因为模块在整页渲染完毕后，offsetTop和scrollHeight值已经是确立的，
    // 所以在滚动监听之前可以先获取，暂存在barList中。
    nextTick(() => {
      // console.log(document.documentElement.scrollTop);
      document.documentElement.scrollTop = 0;
    });
    setTimeout(() => {
      console.log(document.documentElement.scrollTop);
      document.documentElement.scrollTop = 0;
      this.barList.forEach((item) => {
        item.offsetTop = document.getElementById(item.id).offsetTop;
        item.scrollHeight = document.getElementById(item.id).scrollHeight;
        console.log("item.offsetTop", item.offsetTop);
        console.log("item.scrollHeight", item.scrollHeight);
      });
    }, 300);
    // 监听滚动事件
    window.addEventListener("scroll", this.onScroll);
  },
  destroy() {
    // 移除监听器
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    handleClick: () => {},
    handleClose() {
      this.dialogVisible = false;
    },
    goArticle(href) {
      this.currentArticle = href;
      this.dialogVisible = true;
      // window.open(href, "_blank");
    },
    // 滚动监听器
    onScroll() {
      this.affixTop = 150;
      // 获取浏览器窗口高度
      let clientHeight =
        window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      // 获取当前文档流的 scrollTop
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // 屏幕垂直中线
      let screenMiddle = scrollTop + 150;
      // console.log("screenMiddle", screenMiddle);
      // console.log("screenMiddle - item.offsetTop", screenMiddle);
      this.barList.find((item) => {
        //以浏览器窗口垂直中线为准，中线在内容模块的上边界至下边界之间，导航栏都认为在该楼层
        // console.log("item.offsetTop", item.offsetTop);
        // console.log("item.scrollHeight", item.scrollHeight);
        if (
          screenMiddle - item.offsetTop >= 0 &&
          screenMiddle - item.offsetTop < item.scrollHeight &&
          this.scrollOn == true
        ) {
          // item.active = 1;
          this.currentBar = item.id;
        }
      });
    },
    // 跳转到指定索引的元素
    scrollTo(item) {
      this.currentBar = item.id;
      // 获取目标的 offsetTop
      // css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
      const targetOffsetTop = document.getElementById(item.id).offsetTop - 140;
      // 获取当前 offsetTop
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉，步子迈大了会扯到蛋
      const STEP = 50;
      // 判断是往下滑还是往上滑
      if (scrollTop > targetOffsetTop) {
        // 往上滑
        this.smoothUp(scrollTop, targetOffsetTop);
      } else {
        // 往下滑
        this.smoothDown(scrollTop, targetOffsetTop);
      }
    },
    // 定义往下滑函数
    smoothDown(scrollTop, targetOffsetTop, STEP) {
      // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
      if (scrollTop < targetOffsetTop) {
        // 如果和目标相差距离大于等于 STEP 就跳 STEP
        // 否则直接跳到目标点，目标是为了防止跳过了。
        if (targetOffsetTop - scrollTop >= STEP) {
          scrollTop += STEP;
          this.scrollOn = false;
        } else {
          this.scrollOn = true;
          scrollTop = targetOffsetTop;
        }
        document.body.scrollTop = scrollTop;
        document.documentElement.scrollTop = scrollTop;
        // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
        requestAnimationFrame(this.smoothDown);
      }
    },
    // 定义往上滑函数
    smoothUp(scrollTop, targetOffsetTop, STEP) {
      if (scrollTop > targetOffsetTop) {
        if (scrollTop - targetOffsetTop >= STEP) {
          scrollTop -= STEP;
          this.scrollOn = false;
        } else {
          scrollTop = targetOffsetTop;
          scrollTop = targetOffsetTop;
        }
        document.body.scrollTop = scrollTop;
        document.documentElement.scrollTop = scrollTop;
        requestAnimationFrame(this.smoothUp);
      }
    },
  },
};
</script>
<style>
.el-dialog .article {
  padding: 60px 100px;
  max-height: 80vh;
  overflow: scroll;
  font-size: 16px;
  line-height: 1.5rem;
  text-align: justify;
  .a-title {
    font-size: 22px;
    text-decoration: underline;
    font-weight: bold;
    padding-bottom: 10px;
  }
  .s-title {
    font-size: 18px;
    font-weight: bold;
    padding-top: 20px;
  }
  p {
    margin-top: 6px;
    font-size: 16px;
    text-align: justify;
    .title {
      font-size: 24px;
    }

    span {
      font-size: 16px;
    }

    b {
      padding: 10px 0;
      display: inline-block;
    }
  }
}

.t-anchor__item-link {
  white-space: nowrap !important;
}

.t-anchor {
  width: 300px !important;
}

.mobile {
  .el-dialog {
    width: 100% !important;
    margin-top: 4vh !important;

    .article {
      padding: 16px 0;
      max-height: 80vh;
      overflow: scroll;

      .title {
        font-size: 18px !important;
        line-height: 22px !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.mobile {
  #about {
    padding-top: 50px !important;

    ::v-deep .el-tabs {
      .el-tabs__header {
        padding: 0 10px !important;
      }

      .el-tabs__content {
        padding: 0 !important;
      }

      .el-tabs__nav-scroll {
        padding: 10px 0 !important;
      }

      .el-tabs__nav-next,
      .el-tabs__nav-prev {
        margin-top: 8px;
      }
    }
  }

  #about {
    padding-top: 50px;
    .our-view {
      .our-item {
        width: 100% !important;
      }
    }
    .page-header {
      position: relative;

      img {
        width: 100%;
        display: block;
      }

      .header-title {
        position: absolute;
        left: fw(205vw, pc);
        bottom: fh(36vh, pc);
        font-size: fh(48vh, pc);
        color: #ffffff;
        line-height: fh(58vh, pc);
      }
    }

    .content-view {
      width: 100% !important;

      .page-title {
        font-size: fh(20vh, h5) !important;
        margin-top: fh(20vh, h5) !important;
      }

      .text {
        margin-top: fh(20vh, h5) !important;
      }

      .img-text {
        position: static !important;
        padding-top: fh(20vh, h5) !important;
        background: #015a73;
        padding-bottom: 200px !important;
      }

      .img-view2 {
        display: block !important;

        img {
          width: 100% !important;
        }

        .info-title {
          padding-top: fh(10vh, h5) !important;
        }
      }

      .article-list .article-item {
        width: 100% !important;
        font-size: fh(16vh, pc);
        line-height: fh(26vh, h5) !important;
        margin: 10px 0;
      }
      .article-list .list-row {
        width: 100% !important;
      }
    }

    .side-bar {
      display: none;
    }
  }
}

#about {
  ::v-deep .el-tabs {
    width: 100%;

    .el-tabs__content {
      padding: fh(20vh, pc) fw(200vw, pc);
    }

    .el-tabs__header {
      width: 100%;
      left: 0;
      background: #ececec;
      padding: 0 fw(200vw, pc);
      margin-bottom: 0;
    }

    .el-tabs__nav-scroll {
      padding: fh(30vh, pc) 0 !important;
    }

    .el-tabs__item {
      font-size: fh(16vh, pc);
      color: #999999;

      &.is-active {
        color: #333333;
        font-size: fh(18vh, pc);
      }
    }

    .el-tabs__active-bar {
      bottom: fh(-30vh, pc);
      background: #0077d4;
    }
  }

  .page-header {
    position: relative;

    img {
      width: 100%;
      display: block;
    }

    .header-title {
      position: absolute;
      left: fw(205vw, pc);
      bottom: fh(36vh, pc);
      font-size: fh(48vh, pc);
      color: #ffffff;
      line-height: fh(58vh, pc);
    }
  }

  .page-content {
    display: flex;
    width: 100%;
    //padding: fh(60vh, pc) fw(200vw, pc);
    padding-top: 0;

    .our-view {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;

      .our-item {
        width: calc(50% - 10px);
        position: relative;
        margin-bottom: 20px;

        img {
          display: flex;
          width: 100%;
        }

        .our-text {
          position: absolute;
          bottom: fh(20vh, pc);
          width: 100%;
          left: 0;
          padding: 0 20px;

          .text-title {
            font-size: fh(32vh, pc);
            padding-bottom: fh(20vh, pc);
          }

          .text-content {
            font-size: fh(16vh, pc);
            line-height: fh(26vh, pc);
            font-weight: 400;
          }
        }
      }
    }

    .content-view {
      width: fw(1180vw, pc);

      &.constitution {
        width: fw(1560vw, pc);
      }
    }

    .side-bar {
      position: relative;
      flex: 1;
      height: 100%;
    }

    .img-view2 {
      display: flex;
      align-items: flex-start;

      img {
        width: fw(366vw, pc);
        display: block;
        margin-right: fw(20vw, pc);
      }

      .img-info {
        flex: 1;

        .info-title {
          font-size: fh(22vh, pc);
          line-height: fh(30vh, pc);
          margin-bottom: fh(10vh, pc);
          font-weight: bold;
          color: #333;
        }

        .info-text {
          font-size: fh(16vh, pc);
          line-height: fh(24vh, pc);
          color: #2a2a2a;
          font-weight: 500;

          p {
            margin-top: 4px;
          }

          span {
            font-weight: bold;
          }
        }
      }
    }

    .img-view {
      width: 100%;
      position: relative;

      img {
        width: 100%;
        display: block;
        margin-top: fh(-200vh, pc);
      }

      .img-text {
        background: linear-gradient(180deg, #015b73 0%, #015a73 80%, rgba(1, 90, 115, 0) 100%);
        width: 100%;
        position: relative;
        padding: fh(40vh, pc) fw(40vw, pc);
        font-size: fh(18vh, pc);
        line-height: fh(28vh, pc);
        color: #fff;
        z-index: 9;
        font-weight: 300;

        p {
          margin-top: fh(40vh, pc);
        }

        ul li {
          position: relative;

          &:before {
            content: "";
            position: absolute;
            width: 4px;
            height: 4px;
            top: 50%;
            transform: translateY(-50%);
            left: fw(-25vw, pc);
            background-color: #fff;
            border-radius: 50%;
          }
        }
      }
    }

    .page-title {
      margin-top: fh(40vh, pc);
      font-weight: bold;
      font-size: fh(36vh, pc);
      color: #333333;
      line-height: fh(54vh, pc);
      text-align: justify;
      margin-bottom: fh(20vh, pc);
    }

    .article-list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-top: fh(20vh, pc);
      .list-row {
        width: 50%;
      }
      .article-item {
        width: 100%;
        font-size: fh(23vh, pc);
        margin: fh(20vh, pc) 0;
        text-decoration: underline;
        font-weight: bold;
        color: #333333;

        &:hover {
          cursor: pointer;
          opacity: 0.8;
        }
      }
    }

    .text {
      margin-top: fh(55vh, pc);
      font-size: fh(18vh, pc);
      color: #2a2a2a;
      line-height: fh(28vh, pc);

      p {
        margin-top: fh(8vh, pc);
      }

      ul {
        margin: 0;
        padding-left: 2rem;

        li {
          margin-top: fh(8vh, pc);
          position: relative;

          &:before {
            content: "";
            position: absolute;
            width: 4px;
            height: 4px;
            top: fh(15vh, pc);
            left: fw(-15vw, pc);
            background-color: #0077d4;
            border-radius: 50%;
          }
        }
      }

      .line {
        padding-bottom: fh(20vh, pc);

        span {
          &:nth-child(1) {
            display: inline-block;
            font-size: fh(18vh, pc);
            color: #bbbbbb;
            line-height: fh(22vh, pc);
            width: fw(200vw, pc);
          }

          &:nth-child(2) {
            font-size: fh(18vh, pc);
            color: #2a2a2a;
            font-weight: bold;
            line-height: fh(22vh, pc);
          }
        }
      }
    }
  }
}
</style>
